export default "__VITE_ASSET__dQ_9Lhet__"